const Discount = {
	amount: true,
	percent: true
};

export { Discount };